"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Post = void 0;
var _react = _interopRequireDefault(require("react"));
require("../cdn.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Post = exports.Post = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tag = "h2",
    image,
    alt = "",
    label = "",
    title,
    href = "",
    target = "",
    onClick = () => null,
    className = ""
  } = _ref;
  const WrapperTag = href ? "a" : "div";
  const HeaderTag = tag;
  const extraProps = {};
  if (href) {
    extraProps["href"] = href;
    if (target) {
      extraProps["target"] = target;
    }
  }
  return /*#__PURE__*/_react.default.createElement(WrapperTag, _extends({
    className: ["card", "card-news", ...className.split(" ")].filter(v => !!v).join(" "),
    onClick: onClick,
    ref: ref
  }, extraProps), /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: alt,
    className: "mb-4"
  }), label && /*#__PURE__*/_react.default.createElement("span", {
    className: "tag mb-4"
  }, label), /*#__PURE__*/_react.default.createElement(HeaderTag, {
    className: "fs-h3"
  }, title));
});